import { POINT_BET_STATUS, POINT_BET_SWAP_STATUS, POINT_BET_SWAP_TYPE, POINT_GAME_TYPE } from '../common/name-space';

export const betGameTypeFilter = (aData: number): string => {
  let re = null;
  switch (aData) {
    case POINT_GAME_TYPE.NONE:
      re = '기타';
      break;
    case POINT_GAME_TYPE.SCRATCH:
      re = '스크래처';
      break;
    case POINT_GAME_TYPE.ROULETTE:
      re = '룰렛';
      break;
    case POINT_GAME_TYPE.LOTTERY:
      re = '로또';
      break;
    default:
      re = '에러';
      break;
  }
  return re;
};

export const betStatusFilter = (aData: number | undefined): string => {
  let re = null;
  switch (aData) {
    case POINT_BET_STATUS.ING:
      re = '참여';
      break;
    case POINT_BET_STATUS.WIN:
      re = '당첨';
      break;
    case POINT_BET_STATUS.SMALL_WIN:
      re = '소액 당첨';
      break;
    case POINT_BET_STATUS.JACKPOT:
      re = '잭팟 당첨';
      break;
    case POINT_BET_STATUS.ADMIN:
      re = '관리자가 지급';
      break;
    case POINT_BET_STATUS.SWAP_TO_POINT:
      re = 'token -> point';
      break;
    case POINT_BET_STATUS.SWAP_TO_TOKEN:
      re = 'point -> token';
      break;
    case POINT_BET_STATUS.REFERRAL_BET:
      re = '레퍼럴 베팅';
      break;
    case POINT_BET_STATUS.REFERRAL_WIN:
      re = '레퍼럴 당첨';
      break;
    case POINT_BET_STATUS.REFERRAL_SMALL_WIN:
      re = '레퍼럴 소액 당첨';
      break;
    default:
      re = '에러';
      break;
  }
  return re;
};

export const betSwapStatusFilter = (aData: number): string => {
  let re = null;
  switch (aData) {
    case POINT_BET_SWAP_STATUS.WAITING:
      re = '대기';
      break;
    case POINT_BET_SWAP_STATUS.COMPLETED:
      re = '완료';
      break;
    case POINT_BET_SWAP_STATUS.FAILED:
      re = '실패';
      break;
    case POINT_BET_SWAP_STATUS.ING:
      re = '진행중';
      break;
    case POINT_BET_SWAP_STATUS.REFUSED:
      re = '거절';
      break;
    default:
      re = '에러';
      break;
  }
  return re;
};

export const betSwapTypeFilter = (aData: number): string => {
  let re = null;
  switch (aData) {
    case POINT_BET_SWAP_TYPE.TOKEN_TO_POINT:
      re = '포인트 충전';
      break;
    case POINT_BET_SWAP_TYPE.POINT_TO_TOKEN:
      re = '토큰 출금';
      break;

    default:
      re = '에러';
      break;
  }
  return re;
};
